import { STATIC_ACTIONS } from '~/Constants/Actions.constants';
import { INeoAction } from '~/store/Actions.interface';

export interface GlobalWarningState {
  hasGlobalWarning: boolean;
}

const INITIAL: GlobalWarningState = {
  hasGlobalWarning: false,
};

export default (state: GlobalWarningState = INITIAL, action: INeoAction): GlobalWarningState => {
  const { name, payload } = action;

  switch (name) {
    case STATIC_ACTIONS.SET_GLOBAL_WARNING:
      return { ...state, hasGlobalWarning: payload };
    case STATIC_ACTIONS.CLEAR_GLOBAL_WARNING:
      return INITIAL;
    default:
      return state;
  }
};
